import { Navigate, useLocation } from "react-router-dom";
import { resolveLegacyPath } from "../lib/legacyPaths";

/**
 * Wraps a fallback element (typically <NotFound />). If the current URL matches
 * a legacy WordPress path (see /app/frontend/src/lib/legacyPaths.js), redirect
 * to the new SPA route instead. Otherwise render `children`.
 *
 * NOTE: This is a client-side redirect (React Router history.replace + HTTP
 * 200 SPA response). For true 301s, add server/CDN-level rules at the
 * hosting layer.
 */
export default function LegacyRedirect({ children }) {
  const { pathname, search } = useLocation();
  const target = resolveLegacyPath(pathname);
  if (target) {
    return <Navigate to={target + (search || "")} replace />;
  }
  return children;
}

// Re-export for convenience so existing imports keep working.
export { resolveLegacyPath };
